import React, { useEffect, useState } from 'react';
import { Button, Empty } from 'antd';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import ProfileHelper from 'utils/apiHelpers/profilehelper';
import ProfileTypeHelper from 'utils/apiHelpers/profiletypehelper';
import { setProfiles } from 'redux/reducers/profiles';
import { isProfileTypesEmptySelector, setProfileTypes } from 'redux/reducers/profileTypes';
import NewProfileForm from './NewProfileForm/NewProfileForm';
import CardGrid from './CardGrid/CardGrid';
import UpdateProfileForm from './UpdateProfileForm/UpdateProfileForm';
import type Profile from '../../models/Profile';
import { transformAzDomainsToArray } from '../../utils/transformAzDomains';

const Home = () => {
  const [showNewProfileForm, setShowNewProfileForm] = useState(false);
  const [showUpdateProfileForm, setShowUpdateProfileForm] = useState(false);
  const [editedProfile, setEditedProfile] = useState<Profile | undefined>();
  const [profileListLoading, setProfileListLoading] = useState(true);
  const [refreshLoading, setRefreshLoading] = useState(false);
  const dispatch = useDispatch();
  const showEmptyMessage = useSelector(isProfileTypesEmptySelector);
  const { t } = useTranslation();

  const InitData = async () => {
    setProfileListLoading(true);
    const profilesResponse = await ProfileHelper.getAll();
    const profileTypesResponse = await ProfileTypeHelper.getAll();

    const transformedProfiles = profilesResponse.data.map((p) => ({
      ...p,
      formValues: transformAzDomainsToArray(p.formValues),
    }));
    dispatch(setProfiles(transformedProfiles));
    dispatch(setProfileTypes(profileTypesResponse.data));

    setProfileListLoading(false);
  };

  useEffect(() => {
    InitData();
    // eslint-disable-next-line
  }, []);

  const onNewProfileClick = () => {
    setShowNewProfileForm(true);
  };

  const onEditProfileClick = (profile: Profile) => {
    setEditedProfile(profile);
    setShowUpdateProfileForm(true);
  };

  const closeCreateForm = () => {
    setShowNewProfileForm(false);
  };
  const closeUpdateForm = () => {
    setShowUpdateProfileForm(false);
  };

  const handleRefreshClick = async () => {
    setRefreshLoading(true);
    await InitData();
    setRefreshLoading(false);
  };

  if (refreshLoading || (!profileListLoading && showEmptyMessage)) {
    return (
      <Empty description={t('home.noPlugins')}>
        <Button onClick={handleRefreshClick} type="primary" loading={refreshLoading}>
          {t('home.refresh')}
        </Button>
      </Empty>
    );
  }

  return (
    <>
      <CardGrid
        onNewProfileClick={onNewProfileClick}
        onEditProfileClick={onEditProfileClick}
        loading={profileListLoading}
      />
      <NewProfileForm
        visible={showNewProfileForm}
        onFormCompleted={closeCreateForm}
        onCancel={closeCreateForm}
      />
      <UpdateProfileForm
        profile={editedProfile}
        visible={showUpdateProfileForm}
        onFormCompleted={closeUpdateForm}
        onCancel={closeUpdateForm}
      />
    </>
  );
};

export default Home;
